// eslint-disable-next-line no-unused-vars
import React, { memo, useCallback, useEffect, useState } from 'react';
import { stringify } from 'query-string';
import { number, bool } from 'prop-types';
import { useTranslation } from 'react-i18next';

import { NWPagination } from 'Components/shared';
import useRouter from 'Hooks/useRouter';

const getValidPage = page => {
  const parsedPage = Number(page);

  return Number.isInteger(parsedPage) && parsedPage > 0 ? parsedPage : 1;
};

const ServicePagination = memo(({
  totalPages,
  recordsPerPage,
  totalRecords,
  loading,
}) => {
  const { push, location, query } = useRouter();
  const { t } = useTranslation();
  const [currentPage, setPage] = useState(getValidPage(query?.page || 1));

  const handleOnChange = value => {
    const payload = {
      ...query
    };
    const newPage = parseInt(value.selected, 10) + 1;
    if (newPage === 1) {
      delete payload.page;
    } else {
      payload.page = newPage;
    }
    push({
      pathname: location.pathname,
      search: stringify(payload)
    });
  };

  const hrefBuilder = useCallback(
    page => stringify({
      ...query,
      page
    }),
    [query]
  );

  useEffect(() => {
    const validPage = getValidPage(query?.page || 1);
    if (currentPage !== validPage) {
      setPage(validPage);
    }
  }, [currentPage, query?.page]);

  return (
    <NWPagination
      page={ currentPage || 1 }
      itemsPerPage={ recordsPerPage || 20 }
      itemsCount={ totalRecords || 0 }
      pageCount={ totalPages || 0 }
      hrefBuilder={ hrefBuilder }
      onPageChange={ handleOnChange }
      loading={ loading }
      itemsName={ t('common.pages.service') }
    />
  );
});

ServicePagination.displayName = 'ServicePaginationContainer';

ServicePagination.propTypes = {
  totalPages: number,
  recordsPerPage: number,
  totalRecords: number,
  loading: bool,
};

export default ServicePagination;
